<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h2">Create Goals</h1>
</div>
<form [formGroup]="actionItemForm" novalidate (ngSubmit)="onSubmit()">
    <div class="pt-5">
        <div class="row">
            <div class="col-lg-8 col-lg-8 col-lg-12">
                <mat-expansion-panel class="blue-light reslt-cards">
                    <mat-expansion-panel-header>
                        <mat-panel-title>SPECIFIC: What do you want to accomplish?</mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-form-field>
                        <input matInput placeholder="Specific" formControlName="specific">
                    </mat-form-field>
                </mat-expansion-panel>
                <div class="pb-3"></div>
                <mat-expansion-panel class="purple reslt-cards">
                    <mat-expansion-panel-header>
                        <mat-panel-title>MEASURABLE: How will you know this is accomplished?</mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-form-field>
                        <input matInput placeholder="Measurable" formControlName="measurable">
                    </mat-form-field>
                </mat-expansion-panel>
                <div class="pb-3"></div>
                <mat-expansion-panel class="green reslt-cards">
                    <mat-expansion-panel-header>
                        <mat-panel-title>ACHIEVABLE: How can you accomplish this goal?</mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-form-field>
                        <input matInput placeholder="Attainable" formControlName="attainable">
                    </mat-form-field>
                </mat-expansion-panel>
                <div class="pb-3"></div>
                <mat-expansion-panel class="black reslt-cards">
                    <mat-expansion-panel-header>
                        <mat-panel-title>RELEVANCE: Does this seem worthwhile?</mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-form-field>
                        <input matInput placeholder="Relevant" formControlName="relevant">
                    </mat-form-field>
                </mat-expansion-panel>
                <div class="pb-3"></div>
                <mat-expansion-panel class="white reslt-cards">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="white-card">TIME-BOUND: When will you complete the goal?</mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-form-field>
                        <input matInput placeholder="Time-Bound" formControlName="timeBound">
                    </mat-form-field>
                </mat-expansion-panel>
                <div class="pb-3"></div>
                <button mat-raised-button color="primary">
                    Add Goal!
                </button>
            </div>
        </div>
    </div>
</form>